import { useState, useEffect } from 'react';
import { translations } from '../i18n/translations';

export const useTranslation = () => {
  const [language, setLanguage] = useState('fr');

  useEffect(() => {
    // Détecter la langue du navigateur
    const userLang = navigator.language || navigator.userLanguage;
    const detectedLang = userLang.startsWith('fr') ? 'fr' : 'en';
    setLanguage(detectedLang);
  }, []);

  const t = (key) => {
    return translations[language]?.[key] || key;
  };

  return { t, language, setLanguage };
};
